import styled from 'styled-components';

import InputSimple from '@r1-frontend/ui-react/components/inputSimple';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';

export const VerificationBlock = styled.div`
    flex-direction: column;
    margin-top: 8px;
    row-gap: 12px;
`;

export const CodeInput = styled(InputSimple)`
    margin-bottom: 0;

    @media (max-width: ${wideBreakpoints.mobile}) {
        max-width: 100%;
    }
`;
